import type { PageLinkFieldDefinition } from './page-link-field/editorActions'
import { parseInnerRouteFromLink } from './parseInnerRouteFromLink'
import type WixData from '@wix/wix-data-core/dist/types/data-api'

interface Params {
  collectionId: string
  itemId: string
  pageLinkField?: PageLinkFieldDefinition
  prefix: string
  wixData: WixData
}

export const getInnerRouteForDynamicPageItem = async ({
  collectionId,
  itemId,
  pageLinkField,
  prefix,
  wixData,
}: Params): Promise<string | undefined> => {
  if (!pageLinkField) {
    return
  }
  const item = await wixData.get(collectionId, itemId).catch(() => null)
  const itemIsNotFound = item === null
  if (itemIsNotFound) {
    return
  }
  const link = item[pageLinkField.key]
  const innerRoute = parseInnerRouteFromLink({ link, prefix })
  return innerRoute
}
